import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useInView, motion } from "framer-motion";
import "./Values.scss";
import TeamMembers from "../Members/TeamMembers";
import backgroundImage from "../../Assets/images/img10.jpg";
import modelImage from "../../Assets/images/aronoffice2.svg";
import icon1 from "../../Assets/images/A.png";
import icon2 from "../../Assets/images/R.png";
import icon3 from "../../Assets/images/O.png";
import icon4 from "../../Assets/images/N.png";

const Values = () => {
  const location = useLocation();
  const teamRef = useRef(null);

  const titleRef = useRef(null);
  const isInView = useInView(titleRef, {
    once: true,
    amount: 0.1, // as low as 10% visible
  });

  useEffect(() => {
    if (location.hash === "#team" && teamRef.current) {
      teamRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  return (
    <section className="values-section ">
      <div
        className="values-banner"
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      >
        <div className="values-overlay" />
        <div className="values-text container text-left">
          <motion.div
            ref={titleRef}
            initial={{ opacity: 0, y: 100 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.99, ease: "easeOut", delay: 0.2 }}
          >
            <h5>ABOUT US</h5>
          </motion.div>
        </div>
      </div>

      <div className="white-container">
        <div className="inner-container"></div>
      </div>

      <div className="values-body container">
        <div className="values-header text-center">
          <motion.div
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.99, ease: "easeOut", delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h4>
              Precision in every detail <br />
              excellence in every build
            </h4>
          </motion.div>
        </div>

        <div className="values-image text-center">
          <motion.div
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.99, ease: "easeOut", delay: 0.2 }}
            viewport={{ once: true }}
          >
            <img src={modelImage} alt="Team inspecting model" />
          </motion.div>
        </div>

        <div className="row values-cards">
          <div className="col-md-3 col-12 mb-4">
            <motion.div
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.99, ease: "easeOut", delay: 0.2 }}
              viewport={{ once: true }}
            >
              <div className="value-card">
                <img src={icon1} alt="High Quality" />
                <h5>Adaptability</h5>
                <p>
                  Adaptability is at the heart of everything we do. By
                  harnessing our industry expertise, we remain steadfast in the
                  face of change. We embrace new technologies and adapt quickly
                  to the evolving challenges around us, ensuring that we stay
                  ahead and continue delivering impactful solutions.
                </p>
              </div>
            </motion.div>
          </div>

          <div className="col-md-3 col-12 mb-4">
            <motion.div
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.99, ease: "easeOut", delay: 0.3 }}
              viewport={{ once: true }}
            >
              <div className="value-card">
                <img src={icon2} alt="Community" />
                <h5>Resilience</h5>
                <p>
                  Resilience is key to our company culture. We believe in
                  building a strong, supportive community that thrives on unity.
                  We ensure this by making sure to celebrate the smallest of
                  achievements, finding occasions to come together as a family —
                  nurturing connection, purpose, and shared success.
                </p>
              </div>
            </motion.div>
          </div>

          <div className="col-md-3 col-12 mb-4">
            <motion.div
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.99, ease: "easeOut", delay: 0.4 }}
              viewport={{ once: true }}
            >
              <div className="value-card">
                <img src={icon3} alt="Environmental" />
                <h5>Optimization</h5>
                <p>
                  Optimization is our constant pursuit. We refine our processes
                  and optimize workflows to drive efficiency and excellence in
                  every project. By striving for continuous improvement, we
                  ensure that the quality of work not only meets but exceeds
                  client expectations, setting new standards of success.
                </p>
              </div>
            </motion.div>
          </div>

          <div className="col-md-3 col-12 mb-4">
            <motion.div
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.99, ease: "easeOut", delay: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="value-card">
                <img src={icon4} alt="Innovation" />
                <h5>Nurture</h5>
                <p>
                  Nurture is essential to our growth. We invest in the
                  development of our team, nurturing their skills and fostering
                  a culture of lifelong learning. As we support each other’s
                  growth, we build an environment of excellence, empowering
                  every individual to reach their full potential.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      <TeamMembers ref={teamRef} />
    </section>
  );
};

export default Values;
